// extracted by mini-css-extract-plugin
module.exports = {"tileWH":"9%","tileContainerWH":"12%","tileContainerLengthMobile":"16%","container":"Goal_container__3hkaZ"};